/* eslint-disable no-underscore-dangle */
import {DEVICE_MANAGEMENT_STATES as managementStates} from '../deviceConstants';

const _ = require('lodash');

class ManagementStateRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('management-state-column');
    this._rootElem.component = this._model;

    this._registerListeners();
    this.render();
  }

  /** ***************************************** */
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /** ***************************************** */

  _shutdown() {
    const prom = new Promise((resolve /* ,reject */) => {
      this._unregisterListeners();
      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
    return prom;
  }

  _registerListeners() {
    this._model.on(
      'ManagementState',
      (this._onManagementStateColumn = this._onManagementStateColumn.bind(this))
    );
  }

  _unregisterListeners() {
    this._model.removeAllListeners('ManagementState');
  }

  /** **************************************** */
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /** **************************************** */
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    const prom = new Promise((resolve /* ,reject */) => {
      this._setManagementStateColumn(this._model._value);
      resolve();
    });
    return prom;
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /** **************************************** */
  /* END COMPONENT RENDERER METHODS          */
  /* START HANDLER METHODS                   */
  /** **************************************** */

  _onManagementStateColumn(newVal) {
    this._setManagementStateColumn(newVal);
  }

  /** **************************************** */
  /* END HANDLER METHODS                     */
  /* START PRIVATE API METHODS               */
  /** **************************************** */

  _setManagementStateColumn(newVal) {
    if (!_.isNil(newVal)) {
      this._rootElem.innerHTML = _.get(managementStates, [newVal, 'title'], 'Unknown');
    } else {
      this._rootElem.innerHTML = '';
    }
  }

  /** **************************************** */
  /*  END PRIVATE API METHODS */
  /** **************************************** */
}

export default ManagementStateRenderer;
